export default __webpack_public_path__ + "static/media/side3.0ba38f03.png";